import React from 'react';

const RadioInput = (props) => {
  return (
      <input type="radio" className="mr-2" {...props} />
  );
}

export default RadioInput;
